import styled from '@emotion/styled';
import React from 'react';

interface InspectorSectionProps {
  title: string;
  children: React.ReactNode;
}

const InspectorSection: React.FC<InspectorSectionProps> = ({ title, children }) => (
  <Root>
    <Title>{title}</Title>
    <Body>{children}</Body>
  </Root>
);

export default InspectorSection;

const Root = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;

  &:last-of-type {
    border-bottom: none;
  }
`;

const Title = styled.h4`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin: 0;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
